module.exports = __webpack_public_path__ + "static/img/22g.e298c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22g.jpg
// module id = nqdz
// module chunks = 0